import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-card-text">
            Hello! I&apos;m <span className="purple">Muniraj M</span> from{" "}
            <span className="purple">Tamil Nadu, India</span>.
            <br />
            I&apos;m a passionate{" "}
            <strong>Full-Stack Software Developer</strong> currently working at{" "}
            <strong>HandletechLabs</strong>.
            <br />
            I specialize in building high-quality web applications using
            technologies like <strong>Laravel (PHP)</strong>,{" "}
            <strong>React.js</strong>, and <strong>MySQL</strong>.
            <br />
            <br />
            I earned my Integrated BCA degree from Don Bosco College, Yelagiri
            Hills, affiliated with Thiruvalluvar University.
            <br />
            <br />
            When I&apos;m not coding, you&apos;ll find me enjoying:
          </p>
          <ul style={{ paddingLeft: 0 }}>
            <li className="about-activity">
              <ImPointRight /> Playing video games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing tech blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring new places
            </li>
          </ul>

          <p className="about-quote">
            &ldquo;Strive to build things that make a difference!&rdquo;
          </p>
          <footer className="blockquote-footer">Muniraj M</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
